export var theme = {
    fonts: {
        display: 'BM-Biotif',
        body: 'Roboto',
    },
    grid: {
        resolution: {
            desktop: {
                width: 1160,
                container: 824,
            },
            tablet: {
                width: 768,
                container: 704,
            },
            mobile: {
                width: 360,
                container: 328,
                margin: 16,
            },
        },
        spacing: {
            xxl: 96,
            xl: 64,
            l: 48,
            md: 32,
            base: 24,
            s: 16,
            xs: 8,
            xxs: 4,
        },
    },
    borderRadius: {
        main: '4px',
        double: '8px',
        pill: '999em',
    },
    primaryColours: {
        aubergine: {
            main: '#320B42',
            darkAubergine: '#240232',
            lightAubergine: '#584361',
        },
        tangerine: {
            main: '#F9644B',
            darkTangerine: '#CC371D',
            superDarkTangerine: '#9C2410',
        },
        cyan: {
            main: '#27D6FF',
            darkCyan: '#06C0EC',
            superDarkCyan: '#0098C8',
        },
        mint: {
            main: '#48E1BB',
            darkMint: '#3CBA9B',
            superDarkMint: '#007668',
        },
        amber: {
            main: '#FCB608',
            lightAmber: '#FDCC52',
            darkAmber: '#E49700',
        },
        slateGray: {
            main: '#909fa4',
            darkSlateGray: '#545A5C',
        },
        paleGray: {
            main: '#DEE3EB',
        },
        white: {
            main: '#ffffff',
        },
        black: {
            main: '#000000',
        },
    },
    tints: {
        amber: '#FFF8E6',
        aubergine: '#DFDAE1',
        darkAubergine: '#BFB6C3',
        superDarkAubergine: '#6F707B',
        lightAubergine: '#F4F1F4',
        tangerine: '#FEF0ED',
        cyan: '#E9FBFF',
        mint: '#E6F6F4',
        darkMint: '#CCF5F1',
        paleGray: '#EEF2F8',
    },
    shadows: {
        mainShadow: '0px 5px 5px rgba(50, 11, 66, 0.05)',
        doubleShadow: '0px 10px 10px rgba(0, 0, 0, 0.1)',
        doubleUpShadow: '0px -10px 10px rgba(0, 0, 0, 0.1)',
        buttonShadow: '0px 3px 7px rgba(0, 0, 0, 0.2)',
    },
    headings: {
        fontFamily: 'BM-Biotif',
        letterSpacing: -0.3,
        fontWeight: 400,
        desktop: {
            hero: {
                fontSize: 56,
                lineHeight: 68,
            },
            h1: {
                fontSize: 48,
                lineHeight: 60,
            },
            h2: {
                fontSize: 40,
                lineHeight: 52,
            },
            h3: {
                fontSize: 32,
                lineHeight: 40,
            },
            h4: {
                fontSize: 24,
                lineHeight: 36,
            },
            h5: {
                fontSize: 18,
                lineHeight: 24,
            },
        },
        tablet: {
            hero: {
                fontSize: 48,
                lineHeight: 60,
            },
            h1: {
                fontSize: 40,
                lineHeight: 52,
            },
            h2: {
                fontSize: 36,
                lineHeight: 48,
            },
            h3: {
                fontSize: 28,
                lineHeight: 36,
            },
            h4: {
                fontSize: 20,
                lineHeight: 28,
            },
            h5: {
                fontSize: 16,
                lineHeight: 20,
            },
        },
        mobile: {
            hero: {
                fontSize: 36,
                lineHeight: 48,
            },
            h1: {
                fontSize: 32,
                lineHeight: 40,
            },
            h2: {
                fontSize: 28,
                lineHeight: 36,
            },
            h3: {
                fontSize: 24,
                lineHeight: 32,
            },
            h4: {
                fontSize: 18,
                lineHeight: 24,
            },
            h5: {
                fontSize: 14,
                lineHeight: 20,
            },
        },
    },
    paragraphs: {
        fontFamily: 'Roboto',
        fontWeight: 'normal',
        letterSpacing: 0,
        desktop: {
            subHeading: {
                fontSize: 24,
                lineHeight: 32,
                marginBottom: 24,
            },
            lead: {
                fontSize: 18,
                lineHeight: 27,
                marginBottom: 18,
            },
            body: {
                fontSize: 16,
                lineHeight: 24,
                marginBottom: 0,
            },
        },
        tablet: {
            subHeading: {
                fontSize: 22,
                lineHeight: 33,
                marginBottom: 22,
            },
            lead: {
                fontSize: 18,
                lineHeight: 27,
                marginBottom: 18,
            },
            body: {
                fontSize: 16,
                lineHeight: 24,
                marginBottom: 0,
            },
        },
        mobile: {
            subHeading: {
                fontSize: 18,
                lineHeight: 27,
                marginBottom: 18,
            },
            lead: {
                fontSize: 16,
                lineHeight: 24,
                marginBottom: 16,
            },
            body: {
                fontSize: 14,
                lineHeight: 21,
                marginBottom: 0,
            },
        },
    },
    labels: {
        fontFamily: 'BM-Biotif',
        textTransform: 'uppercase',
        fontWeight: 400,
        letterSpacing: 0.2,
        small: {
            fontSize: 12,
            lineHeight: '16px',
        },
        medium: {
            fontSize: 14,
            lineHeight: '18px',
        },
        large: {
            fontSize: 16,
            lineHeight: '20px',
        },
        extraLarge: {
            fontSize: 20,
            lineHeight: '24px',
        },
    },
    links: {
        fontFamily: 'Roboto',
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '20px',
    },
    special: {
        fontFamily: 'Roboto',
        navigation: {
            fontWeight: 'bold',
            fontSize: 14,
            lineHeight: 20,
            letterSpacing: 0.8,
        },
        reg: {
            fontFamily: 'UKNumberPlate',
            fontSize: 24,
        },
        sectionSubHeading: {
            fontSize: 18,
            lineHeight: 27,
            marginBottom: 18,
        },
        caption: {
            fontSize: 12,
            lineHeight: 24,
            marginBottom: 16,
            letterSpacing: 0.2,
        },
        captionLarge: {
            fontSize: 14,
            lineHeight: 18,
            marginBottom: 16,
            letterSpacing: 0.2,
        },
        category: {
            fontFamily: 'BM-Biotif',
            fontWeight: 'bold',
            letterSpacing: 0.2,
            xLarge: {
                fontSize: 20,
                lineHeight: 24,
            },
            large: {
                fontSize: 16,
                lineHeight: 20,
            },
            medium: {
                fontSize: 14,
                lineHeight: 18,
            },
            small: {
                fontSize: 12,
                lineHeight: 16,
            },
        },
        footerLink: {
            fontFamily: 'Roboto',
            letterSpacing: 0.8,
            fontWeight: 500,
            mobile: {
                fontSize: 12,
                lineHeight: 20,
            },
            tablet: {
                fontSize: 14,
                lineHeight: 22,
            },
        },
        button: {
            font: {
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontFamily: 'Roboto',
                fontSize: 14,
                lineHeight: '16px',
                letterSpacing: 1.4,
            },
        },
        dropdown: {
            font: {
                fontFamily: 'Roboto',
                fontSize: 14,
                lineHeight: '20px',
            },
        },
        value: {
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 10,
            letterSpacing: 0.2,
        },
        valueBold: {
            fontFamily: 'Roboto',
            fontWeight: 700,
            fontSize: 16,
            lineHeight: 10,
            letterSpacing: 0.2,
        },
    },
    overlays: {
        mobile: {
            width: '100%',
            padding: '64px 24px 42px 24px',
        },
        tablet: {
            width: 588,
            padding: '88px 48px 64px 48px',
        },
        desktop: {
            width: 696,
            padding: '88px 48px 64px 48px',
        },
    },
};
export default theme;
